import { commonForms } from "./common";
import { speechTherapistForms } from "./speechTherapist";
import { psychologistForms } from "./psychologist";
import { psychotherapistForms } from "./psychotherapist";
import { occupationalTherapistForms } from "./occupationalTherapist";

export const ALL_SYSTEM_FORMS = [
  ...commonForms,
  ...speechTherapistForms,
  ...psychologistForms,
  ...psychotherapistForms,
  ...occupationalTherapistForms,
].map((item) => ({ ...item, isSystem: true }));

export const getSystemForms = (clinicType) =>
  ALL_SYSTEM_FORMS.filter((f) => f.clinicTypes.includes(clinicType));
